import React, { useState } from 'react'
import { useSelector, useStore, useDispatch } from 'react-redux'
import { Menu } from 'antd'
import { Link } from 'react-router-dom'
import CustomScrollbars from '../../util/CustomScrollbars'
import SidebarLogo from './SidebarLogo'
import Skeleton from 'react-loading-skeleton'
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from '../../constants/ThemeSetting'
import {
  loadIsRegistorOpen,
  loadIsRegistorLoading,
  loadStoreOutlets,
  loadCashListingLoading,
  loadCashListingDataLoading,
  loadClosedRegData,
  loadStoreUsers,
  loadOpenCloseListingDataLoad
} from '../../appRedux/actions/Sell'
import {
  loadReceiptTemplates,
  loadStoreChange
} from '../../appRedux/actions/Setup'
import {
  loadIsDayPast,
  loadOpenClosePaySummary,
  loadSubPermService
} from '../../appRedux/actions/CommonData'
import store from '../../MyStore'
import ds from '../../Services/DataServices'
import SidebarOutletsRegisters from './SidebarOutletsRegisters'
import { message } from 'antd'
import RegOpenDialog from '../../components/RegOpenDialog'
import { useHistory } from 'react-router-dom'
import {
  HOME,
  MAIN_SALE_SCREEN,
  OPEN_CLOSE,
  SALE_HISTORY,
  CASH_LISTING,
  STATUS,
  SELL_SETTING,
  SALE_TRACKING_SCREEN,
  PRODUCT_SCREEN,
  CUSTOMER,
  SALES_LEDGER,
  REPORTS_DASHBOARD,
  STOCK_LIST,
  GENERAL_SCREEN
} from '../../constants/Pages'
import {
  GetIndexDBDataByTableName,
  saveEntitiesDatatoIndexBD
} from '../../appRedux/actions/IndexDBActions'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_TABLES
} from '../../constants/IndexDBData'
import { CONFIG_LOGS } from '../../constants/IndexDB_Logs'
import {
  AppstoreOutlined,
  GoldOutlined,
  PieChartOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  TagsFilled,
  TagsOutlined,
  TeamOutlined
} from '@ant-design/icons'

const MenuItemGroup = Menu.ItemGroup

const SidebarContent = () => {
  const Store = useStore()
  const history = useHistory()

  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const storeUsersChange = useSelector(({ Setup }) => Setup.storeUsersChange)
  const getReduxIsRegisterOpen = useSelector(
    ({ Sell }) => Sell.cashManageIsRegistorOpen
  )
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )
  const getReduxCashListingDataLoading = useSelector(
    ({ Sell }) => Sell.cashListingDataLoading
  )
  const getReduxTemplatesUpdated = useSelector(
    ({ Setup }) => Setup.isReceiptTemplateUpdated
  )
  const getReduxOpenListingDataLoad = useSelector(
    ({ Sell }) => Sell.openCloseListingDataLoad
  )
  const getReduxShowRegSel = useSelector(
    ({ commonConfigs }) => commonConfigs.getIsSelectReg
  )

  const refSate = React.useRef()
  const dispatch = useDispatch()
  // const [languageId, setLanguageId] = React.useState("en");
  const [getIsShowOutReg, setIsShowOutReg] = React.useState(false)
  // React.useEffect(() => {
  //   //console.log(Store.getState())
  //   const unsub = Store.subscribe(handleHistoryMenu);
  //   dispatch(getMenu());
  //   //unsub();
  //   //refSate.current=true;
  //   return () => {
  //     unsub();
  //   };
  // }, [languageId]);

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      setIsShowOutReg(true)
      localStorage.setItem('ShowOutReg', true)
    }
    return () => (mounted = false)
  }, [getReduxShowRegSel])

  React.useEffect(() => {
    // // NOTE: load store outlets
    if (!window.location.href.includes("UserVerify")) {
      // if (isOnline) {
      //   dispatch(loadStoreOutlets(true));
      // }
      dispatch(loadSubPermService(isOnline));
      const getShow = localStorage.getItem("ShowOutReg");
      if (
        isOnline &&
        getShow &&
        window.location.pathname.toLowerCase().includes("/sell")
      ) {
        setIsShowOutReg(true);
        localStorage.setItem("ShowOutReg", true);
      } else {
        setIsShowOutReg(false);
      }
      // dispatch(loadStoreUsers());
    }
  }, [isOnline]);

  // //forReceiptTemplates
  // React.useEffect(() => {
  //   if (!window.location.href.includes('UserVerify')) {
  //     dispatch(loadReceiptTemplates(isOnline))
  //   }
  // }, [getReduxTemplatesUpdated, isOnline])

  // React.useEffect(() => {
  //   //load store users
  //   let mounted = true
  //   if (
  //     mounted &&
  //     !window.location.href.includes('UserVerify') &&
  //     storeUsersChange
  //   ) {
  //     dispatch(loadStoreUsers())
  //     dispatch(loadStoreChange(false))
  //   }
  //   return () => (mounted = false)
  // }, [storeUsersChange])

  // React.useEffect(() => {
  //   // //  NOTE: register open check
  //   let localRegID =
  //     localStorage.getItem("selectedReg") != ""
  //       ? JSON.parse(localStorage.getItem("selectedReg"))
  //       : false;
  //   let regID =
  //     getReduxSelectedOutletReg && getReduxSelectedOutletReg.id
  //       ? getReduxSelectedOutletReg.id
  //       : localRegID && localRegID.id
  //       ? localRegID.id
  //       : false;
  //   if (regID) {
  //     dispatch(loadCashListingLoading(true));
  //     dispatch(loadIsRegistorLoading(true));
  //     let body = {
  //       registerID: regID,
  //     };
  //     if (isOnline) getCheckRegisterOpen(body);
  //     else checkRegFromIndex();
  //   } else {
  //     dispatch(loadIsRegistorLoading(false));
  //     dispatch(loadCashListingLoading(false));
  //   }
  // }, [getReduxIsRegisterOpen, getReduxSelectedOutletReg, isOnline]);

  // async function getCheckRegisterOpen(body) {
  //   const getRegister = ds.getRegisterInfoService(body);
  //   await getRegister
  //     .then(async (res) => {
  //       if (res) {
  //         processCheckReg(res, "ds.getRegisterInfoService");
  //         let data_body = { ...res };
  //         data_body.config_key = CONFIG_LOGS.REG_OPEN;
  //         await saveEntitiesDatatoIndexBD(
  //           [data_body],
  //           INDEX_DB_NAME,
  //           CURRENT_VERSION,
  //           INDEX_DB_TABLES.CONFIGDATA,
  //           "getCheckRegisterOpen"
  //         );
  //       }
  //     })
  //     .catch((e) => {
  //       if (!window.location.href.includes("UserVerify")) {
  //         dispatch(loadIsRegistorLoading(false));
  //         // if (e.response && e.response.status === 401) {
  //         //   message.error("Token Expired! Redirecting to Login Page");
  //         //   setTimeout(() => {
  //         //     dispatch(userLogOut(store.getState()));
  //         //   }, 3000);
  //         // } else {
  //         //   message.error("Something went wrong...");
  //         // }
  //       }
  //     }); //console.log("CatchAddEditBook", e));
  // }

  // function checkRegFromIndex() {
  //   const data = GetIndexDBDataByTableName(
  //     INDEX_DB_NAME,
  //     INDEX_DB_TABLES.CONFIGDATA
  //   );
  //   data
  //     .then((e) => {
  //       if (e && e.length > 0) {
  //         const dataExist = e.filter(
  //           (er) => er.config_key == CONFIG_LOGS.REG_OPEN
  //         );
  //         if (dataExist && dataExist.length > 0) {
  //           processCheckReg(dataExist[0], "checkRegFromIndex");
  //         }
  //       } else {
  //         console.error(
  //           "INDEX_DB_DATA_NOT_FOUND -> INDEX_DB_TABLES.CONFIGDATA -->",
  //           e
  //         );
  //       }
  //     })
  //     .catch((e) => {
  //       console.error("INDEX_DB_CONFIGS_ERROR -> checkRegFromIndex -->", e);
  //     });
  // }

  // function processCheckReg(res, from) {
  //   try {
  //     if (res.extraPrinters) {
  //       localStorage.setItem("extraPrints", "1");
  //     } else {
  //       localStorage.setItem("extraPrints", "0");
  //     }
  //     if (res.isOpen) {
  //       let id = res.id;

  //       //if day past since opening reg
  //       if (res.isTimeExceed && isOnline) {
  //         dispatch(loadIsDayPast(true));
  //       }

  //       //calling regInfo to display in open/close with already present check!!!
  //       let localSavedCashID =
  //         localStorage.getItem("cashManageID") &&
  //         localStorage.getItem("cashManageID") != ""
  //           ? localStorage.getItem("cashManageID")
  //           : false;
  //       localSavedCashID =
  //         localSavedCashID && localSavedCashID.includes("&")
  //           ? localSavedCashID.substring(0, localSavedCashID.indexOf("&"))
  //           : false;
  //       if (
  //         !localStorage.getItem("cashManageID") ||
  //         localStorage.getItem("cashManageID") == "" ||
  //         (localSavedCashID &&
  //           localSavedCashID != id.substring(0, id.indexOf("&")))
  //       ) {
  //         let body = {
  //           CashManagementID: id,
  //         };
  //         dispatch(loadClosedRegData(body, false));
  //       }
  //       localStorage.setItem("cashManageID", id);
  //       dispatch(loadIsRegistorOpen(true));
  //       dispatch(loadIsRegistorLoading(false));
  //       dispatch(loadIsRegistorLoading(false));
  //       dispatch(loadCashListingLoading(false));
  //       if (!window.location.pathname.includes("/openclose/listing")) {
  //         dispatch(loadOpenCloseListingDataLoad(!getReduxOpenListingDataLoad)); //to load data in Open/Close -> OpenListing
  //       }

  //       // call for open/close cash Component
  //       let bodyForComp = {
  //         CMID: id,
  //         OutID: "",
  //         IsClosed: false,
  //       };
  //       dispatch(loadOpenClosePaySummary(bodyForComp));

  //       dispatch(loadCashListingDataLoading(!getReduxCashListingDataLoading));
  //     } else {
  //       dispatch(loadIsRegistorOpen(false));
  //       dispatch(loadIsRegistorLoading(false));
  //       dispatch(loadIsRegistorLoading(false));
  //       dispatch(loadCashListingLoading(false));
  //       localStorage.setItem("cashManageID", "");
  //     }
  //   } catch (e) {
  //     console.error(
  //       `SETUP_INDEX_DB_CONFIGS_ERROR -> processCheckReg_from_${from} -->`,
  //       e
  //     );
  //   }
  // }

  // const handleHistoryMenu = () => {
  //   //console.log(Store.getState().settings.locale.locale);
  //   if (languageId != Store.getState().settings.locale.locale) {
  //     setLanguageId(Store.getState().settings.locale.locale);
  //     // dispatch(getMenu());
  //   }
  //   /* if(Store.getState().auth.reloadMenu){
  //          // unsub();

  //          dispatch(getMenu())
  //          // var menuNavigationData = localStorage.getItem('menu');
  //          // renderWholeMenu();
  //       }*/
  // };

  const MenuIcons = props => {
    const { pageID } = props
    switch (pageID) {
      case HOME:
        return <AppstoreOutlined style={{ fontSize: 'x-large' }} />
      case MAIN_SALE_SCREEN:
        return <ShoppingCartOutlined style={{ fontSize: 'x-large' }} />
      case REPORTS_DASHBOARD:
        return <PieChartOutlined style={{ fontSize: 'x-large' }} />
      case PRODUCT_SCREEN:
        return <TagsOutlined style={{ fontSize: 'x-large' }} />
      case STOCK_LIST:
        return <GoldOutlined style={{ fontSize: 'x-large' }} />
      case CUSTOMER:
        return <TeamOutlined style={{ fontSize: 'x-large' }} />
      case GENERAL_SCREEN:
        return <SettingOutlined style={{ fontSize: 'x-large' }} />
      default:
        return <></>
    }
  }

  function onParentMenuClick (menu) {
    if (
      menu &&
      menu.pageID &&
      (menu.pageID == HOME ||
        menu.pageID == MAIN_SALE_SCREEN ||
        menu.pageID == OPEN_CLOSE ||
        menu.pageID == SALE_HISTORY ||
        menu.pageID == CASH_LISTING ||
        menu.pageID == STATUS ||
        menu.pageID == SELL_SETTING ||
        menu.pageID == SALE_TRACKING_SCREEN)
    ) {
      if (menu.pageID == 1) {
        history.push('/dashboard')
      } else {
        if (isOnline) {
          setIsShowOutReg(true)
          localStorage.setItem('ShowOutReg', true)
        }
      }
    } else {
      localStorage.removeItem('ShowOutReg')
      setIsShowOutReg(false)
    }
  }

  let menuNavigationData = localStorage.getItem('menu')
  const renderWholeMenu = () => {
    if (menuNavigationData != null) {
      menuNavigationData = JSON.parse(menuNavigationData)
      return menuNavigationData.menus
        .filter(menu => menu.parentMenuNavigationID == 0)
        .map(menu => (
          <SubMenu
            key={menu.menuURL}
            popupClassName={getNavStyleSubMenuClass(navStyle)}
            title={
              <span onClick={() => onParentMenuClick(menu)}>
                <MenuIcons pageID={`${menu.pageID}`} />
                {
                  /* <i className={menu.iconClassName} />*/
                  <span>{menu.displayText}</span>
                }
              </span>
            }
            disabled={menu.pageID != MAIN_SALE_SCREEN && !isOnline}
          >
            {menuNavigationData.menus
              .filter(
                submenu =>
                  submenu.parentMenuNavigationID == menu.menuNavigationID
              )
              .map(submenu => (
                <Menu.Item
                  key={submenu.menuURL}
                  disabled={
                    submenu.pageID != MAIN_SALE_SCREEN &&
                    submenu.pageID != STATUS &&
                    !isOnline
                  }
                >
                  <Link
                    onClick={() => onParentMenuClick(submenu)}
                    to={submenu.menuURL}
                  >
                    <span>{submenu.displayText}</span>
                  </Link>
                </Menu.Item>
              ))}
          </SubMenu>
        ))
    }
  }

  let { navStyle, themeType, pathname } = useSelector(
    ({ settings }) => settings
  )

  const getNoHeaderClass = navStyle => {
    if (
      navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return 'gx-no-header-notifications'
    }
    return ''
  }

  const url = window.location.href.split(window.location.origin)
  const selectedKeys = url.length > 0 ? url[1] : ''
  //   const defaultOpenKeys = selectedKeys.split("/")[1];
  const getNavStyleSubMenuClass = navStyle => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return 'gx-no-header-submenu-popup'
    }
    return ''
  }
  const SubMenu = Menu.SubMenu

  return (
    <>
      {'' != null ? (
        <SidebarLogo />
      ) : (
        <Skeleton className='sidebar-logo-skeleton' />
      )}

      <div
        className='gx-sidebar-content sidebar-con-div'
        style={{ backgroundColor: '#0b233a' }}
      >
        {getIsShowOutReg && (
          <div
            className={`dk-sidebar-notifications ${getNoHeaderClass(navStyle)}`}
          >
            <SidebarOutletsRegisters />
          </div>
        )}

        {menuNavigationData != null ? (
          <CustomScrollbars className='gx-layout-sider-scrollbar'>
            <Menu
              selectedKeys={[selectedKeys]}
              theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
              mode='inline'
              style={{ marginTop: getIsShowOutReg ? '-25px' : '0px' }}
            >
              <MenuItemGroup key='main' className='gx-menu-group'>
                {renderWholeMenu()}
              </MenuItemGroup>
            </Menu>
          </CustomScrollbars>
        ) : (
          <div className='sidebar-main-skeleton'>
            {<Skeleton className='sidebar-menu-skeleton' count={7} />}
          </div>
        )}
      </div>
    </>
  )
}

SidebarContent.propTypes = {}

export default SidebarContent
